import { ModuleModel } from '../../module.model.interface';
import { DataEntryDescriptor, DataEntryState } from '../../dataentry/model/dataentry';
import { ProfileModel } from '../../profile/model/profile.model';

export class DataEntryHistoryDescriptor implements ModuleModel {
  public discriminator = 'DataEntryHistoryDescriptor';

  public id: string;

  public dataEntryId: string;
  public message: string;
  public previousState: string;
  public currentState: string;
  public createdBy: string;
  public createdOn: Date;

  public href: string;
  public modified: Date;
  public deleted: Date;

  public profileDetail: ProfileModel;
  public profileFullName: string;

  constructor(options?: {
    id: string;

    dataEntryId: string;
    message: string;
    previousState: string;
    currentState: string;
    createdBy: string;
    createdOn: Date;

    href: string;
    modified: Date;
    deleted: Date;
  }) {

    if (options) {
      this.id = options.id;

      this.dataEntryId = options.dataEntryId;
      this.message = options.message;
      this.previousState = options.previousState;
      this.currentState = options.currentState;
      this.createdBy = options.createdBy;
      this.createdOn = options.createdOn;

      this.modified = options.modified;
      this.deleted = options.deleted;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/dataentry.history/model/dataentry.history.ts